/**
 * dev-ops-aware-devices-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T23:28:47Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * A set of statistics for a measurement frame
 */
export interface MeasurementStats { 
    /**
     * The average measurement
     */
    average: number;
    /**
     * The maximum measurement
     */
    max: number;
    /**
     * The minimum measurement
     */
    min: number;
}
